import React from 'react';
import { Star, Quote } from 'lucide-react';
import { testimonials } from '../../data/mock';

const TestimonialsSection = () => {
  return (
    <section className="relative py-24 lg:py-32">
      {/* Background */}
      <div className="absolute inset-0 bg-gradient-to-b from-[#050505] via-black to-[#050505]" />
      
      <div className="relative max-w-7xl mx-auto px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center max-w-3xl mx-auto mb-16">
          <span className="text-[#00D4FF] text-sm font-semibold tracking-wider uppercase mb-4 block">
            Testimonials
          </span>
          <h2 className="text-3xl lg:text-5xl font-bold text-white mb-6">
            Trusted by Florida Businesses
          </h2>
          <p className="text-gray-400 text-lg leading-relaxed">
            See what our clients say about our professional armed security services.
          </p>
        </div>

        {/* Testimonials Grid */}
        <div className="grid md:grid-cols-3 gap-6">
          {testimonials.map((testimonial) => (
            <div
              key={testimonial.id}
              className="group relative bg-gradient-to-br from-white/[0.05] to-transparent border border-white/10 p-8 hover:border-[#00D4FF]/30 transition-all duration-500"
            >
              {/* Quote icon */}
              <div className="absolute top-6 right-6 text-[#00D4FF]/20">
                <Quote className="w-10 h-10" />
              </div>

              {/* Stars */}
              <div className="flex gap-1 mb-6">
                {[...Array(testimonial.rating)].map((_, i) => (
                  <Star
                    key={i}
                    className="w-4 h-4 fill-[#00D4FF] text-[#00D4FF]"
                  />
                ))}
              </div>

              {/* Content */}
              <p className="text-gray-300 leading-relaxed mb-8">
                "{testimonial.content}"
              </p>

              {/* Author */}
              <div className="border-t border-white/10 pt-6">
                <p className="text-white font-semibold">{testimonial.name}</p>
                <p className="text-sm text-gray-500">{testimonial.role}</p>
                <p className="text-sm text-[#00D4FF]">{testimonial.company}</p>
              </div>

              {/* Placeholder indicator */}
              {testimonial.isPlaceholder && (
                <div className="absolute bottom-4 right-4">
                  <span className="text-[10px] text-gray-600 uppercase tracking-wider">
                    Example
                  </span>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TestimonialsSection;
